import React from 'react';
import PropTypes from 'prop-types';
import HeaderWithSidebar from '@templates/HeaderWithSidebar';
import { TopSection } from './style';

const OrganisationProfileTemplate = ({ background, children }) => (
  <HeaderWithSidebar contentPadding={0}>
    <TopSection background={background} />
    {children}
  </HeaderWithSidebar>
);

OrganisationProfileTemplate.propTypes = {
  background: PropTypes.string,
  children: PropTypes.object,
};

OrganisationProfileTemplate.defaultProps = {
  background: '',
  children: undefined
};

export default OrganisationProfileTemplate;
